var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"c-index-menu_list"},_vm._l((_vm.menu),function(item,index){return _c('div',{key:index,staticClass:"c-index-menu_list_item",on:{"click":function($event){return _vm.toMenu(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }